var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRosette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03276 13.424L8.27768 13.3054L8.52056 13.4281L11.1605 14.7622L9.8423 4.68745H6.7079L5.24262 14.7753L8.03276 13.424Z",
    fill: "white",
    stroke: "#36AFC1",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27882 10.3972C10.7067 10.3972 12.6747 8.42904 12.6747 6.0014C12.6747 3.57375 10.7067 1.60555 8.27882 1.60555C5.85123 1.60555 3.88325 3.57373 3.88325 6.0014C3.88325 8.42906 5.85123 10.3972 8.27882 10.3972Z",
    fill: "white",
    stroke: "#36AFC1",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosette);
export default __webpack_public_path__ + "static/media/rosette.a7e47cc303c58f1372c57be5da77bfd1.svg";
export { ForwardRef as ReactComponent };